export default function PHP_glob() {
  return (
    <div>
      <h1>PHP_glob</h1>
    </div>
  );
}
